import React, { FC } from 'react';
import { Box, FormLabel, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import styles from './CustomSelect.module.scss';

interface CustomSelectProps {
  name: string;
  inputLabel: string;
  value: string;
  customClass?: string;
  required?: boolean;
  data: string[];
  handleChange: (e: SelectChangeEvent<string>) => void;
}

const CustomSelect: FC<CustomSelectProps> = ({ name, inputLabel, value, handleChange, required = false, customClass, data }) => {
  return (
    <Box id={styles.customSelectContainer} className={customClass}>
      <FormLabel className={styles.customSelectLabel}>
        <Typography variant='h11Semibold'>{inputLabel}</Typography>
      </FormLabel>
      <Select
        id={name}
        labelId={name}
        name={name}
        value={value}
        required={required}
        className={styles.customInput}
        onChange={handleChange}
        IconComponent={ExpandMoreIcon}
        displayEmpty
      >
        <MenuItem value="" disabled>
          <em>Select an option</em>
        </MenuItem>
        {data.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}
      </Select>
    </Box>
  )
}

export default CustomSelect;
